var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPerson(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.25977 8.34375C7.52344 8.34375 7.19336 8.75 6 8.75C4.78125 8.75 4.45117 8.34375 3.71484 8.34375C1.83594 8.34375 0.3125 9.89258 0.3125 11.7715V12.4062C0.3125 13.0918 0.845703 13.625 1.53125 13.625H10.4688C11.1289 13.625 11.6875 13.0918 11.6875 12.4062V11.7715C11.6875 9.89258 10.1387 8.34375 8.25977 8.34375ZM10.4688 12.4062H1.53125V11.7715C1.53125 10.5527 2.49609 9.5625 3.71484 9.5625C4.0957 9.5625 4.67969 9.96875 6 9.96875C7.29492 9.96875 7.87891 9.5625 8.25977 9.5625C9.47852 9.5625 10.4688 10.5527 10.4688 11.7715V12.4062ZM6 7.9375C8.00586 7.9375 9.65625 6.3125 9.65625 4.28125C9.65625 2.27539 8.00586 0.625 6 0.625C3.96875 0.625 2.34375 2.27539 2.34375 4.28125C2.34375 6.3125 3.96875 7.9375 6 7.9375ZM6 1.84375C7.32031 1.84375 8.4375 2.96094 8.4375 4.28125C8.4375 5.62695 7.32031 6.71875 6 6.71875C4.6543 6.71875 3.5625 5.62695 3.5625 4.28125C3.5625 2.96094 4.6543 1.84375 6 1.84375Z",
    fill: "#6C757D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerson);
export default __webpack_public_path__ + "static/media/person.eaf1bc96.svg";
export { ForwardRef as ReactComponent };